import { render, staticRenderFns } from "./adb-dialog.vue?vue&type=template&id=2b32e401&scoped=true&"
import script from "./adb-dialog.vue?vue&type=script&lang=js&"
export * from "./adb-dialog.vue?vue&type=script&lang=js&"
import style0 from "./adb-dialog.vue?vue&type=style&index=0&id=2b32e401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32e401",
  null
  
)

export default component.exports